const SerialNumberInfoApp = ({ serialNumberInfo }) => {
  console.log('SerialNumberInfoApp serialNumber:', serialNumberInfo);

  const {
    serial_number: serialNumber,
    product_key: productKey,
    product_name: productName,
    hardware_escalation: hardwareEscalation,
    units,
    warranty_allotments: warrantyAllotments,
  } = serialNumberInfo;

  const renderUnits = () => {
    return (
      <ol>
        {units.map((unit, index) => {
          const { sku, order: orderNumber, return_items: returnItems } = unit;

          return (
            <li key={index}>
              <div>SKU: {sku}</div>
              <div>
                Order Number:{' '}
                <a
                  href={`/admin/health/order/${orderNumber}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {orderNumber}
                </a>
              </div>
              <div>
                <strong>Return Items:</strong>
                <ol>
                  {returnItems.map((returnItem, index) => {
                    const {
                      return_authorization: returnAuthorizationNumber,
                      return_item: returnItemId,
                      return_item_reception_status: returnItemReceptionStatus,
                    } = returnItem;

                    return (
                      <li key={index}>
                        <div>
                          Return Authorization Number:{' '}
                          {returnAuthorizationNumber}
                        </div>
                        <div>Return Item ID: {returnItemId}</div>
                        <div>
                          Return Item Reception Status:{' '}
                          {returnItemReceptionStatus}
                        </div>
                      </li>
                    );
                  })}
                </ol>
              </div>
            </li>
          );
        })}
      </ol>
    );
  };

  const renderWarrantyAllotments = () => {
    return (
      <ol>
        {warrantyAllotments.map((warrantyAllotment, index) => {
          const {
            warranty_allotment_id: warrantyAllotmentId,
            warranty_allotment_product_key: warrantyAllotmentProductKey,
            orders: {
              warranty_return_order_number: warrantyReturnOrderNumber,
              warranty_return_order_status: warrantyReturnOrderStatus,
              warranty_replacement_order_number: warrantyReplacementOrderNumber,
              warranty_replacement_order_status: warrantyReplacementOrderStatus,
            },
            merchant_token: merchantToken,
            claimed,
            expired,
            sq_user_agent: sqUserAgent,
          } = warrantyAllotment;

          return (
            <li key={index}>
              <div>Warranty Allotment ID: {warrantyAllotmentId}</div>
              <div>
                Warranty Allotment Product Key: {warrantyAllotmentProductKey}
              </div>
              <div>
                Warranty Return Order Number:{' '}
                <a
                  href={`/admin/health/order/v2/${warrantyReturnOrderNumber}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {warrantyReturnOrderNumber}
                </a>
              </div>
              <div>
                Warranty Return Order Status: {warrantyReturnOrderStatus}
              </div>
              <div>
                Warranty Replacement Order Number:{' '}
                <a
                  href={`/admin/health/order/v2/${warrantyReplacementOrderNumber}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {warrantyReplacementOrderNumber}
                </a>
              </div>
              <div>
                Warranty Replacement Order Status:{' '}
                {warrantyReplacementOrderStatus}
              </div>
              <div>
                Merchant Token:{' '}
                <a
                  href={`https://regulator.sqprod.co/n/merchants/${merchantToken}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {merchantToken}
                </a>
              </div>
              <div>Claimed: {claimed.toString()}</div>
              <div>Expired: {expired.toString()}</div>
              <div>sq_user_agent: {sqUserAgent}</div>
            </li>
          );
        })}
      </ol>
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ margin: 0 }}>
        Serial Number Information for SN: {serialNumber}
      </h2>
      <h5 style={{ marginTop: 20, marginBottom: 10 }}>Basic Information</h5>
      <div>Product Key: {productKey}</div>
      <div>Product Name: {productName}</div>
      {hardwareEscalation && (
        <div>
          Notes: <b style={{ color: '#D70000' }}>HQ D2O</b>
        </div>
      )}
      <h5 style={{ marginTop: 20, marginBottom: 10 }}>
        Units from Orders / Returns / Warranties
      </h5>
      <p>
        If the return item is state <strong>canceled</strong>, it means the
        return item will not interfere with the warranty allotment.
      </p>
      <div>{renderUnits()}</div>
      <h5 style={{ marginTop: 20, marginBottom: 10 }}>Warranty Allotments</h5>
      <p>
        Make sure to check the regulator profile of the merchant to verify the
        allotment product is in the same geo as the merchant themselves, if
        there is a mismatch, it needs to be fixed.
      </p>
      <div>{renderWarrantyAllotments()}</div>
    </div>
  );
};

export default SerialNumberInfoApp;
